import { render, staticRenderFns } from "./childAgreement.vue?vue&type=template&id=20f1a334&scoped=true"
import script from "./childAgreement.vue?vue&type=script&lang=js"
export * from "./childAgreement.vue?vue&type=script&lang=js"
import style0 from "./childAgreement.vue?vue&type=style&index=0&id=20f1a334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1a334",
  null
  
)

export default component.exports